import React from "react";
import { Icon, IconBaseProps } from "./Icon";

const CloseModalIcon: React.FC<IconBaseProps> = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M13.15 12.09a.125.125 0 010-.178l4.631-4.63A.75.75 0 1016.72 6.22l-4.631 4.629a.125.125 0 01-.177 0L7.28 6.221a.75.75 0 10-1.061 1.06l4.63 4.631a.125.125 0 010 .177l-4.63 4.632a.75.75 0 001.06 1.06l4.632-4.631a.125.125 0 01.177 0l4.63 4.631a.75.75 0 101.062-1.06z" />
  </Icon>
);
export default CloseModalIcon;
